import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
export var Bridge = /*#__PURE__*/_createClass(function Bridge() {
  _classCallCheck(this, Bridge);
});
_defineProperty(Bridge, "addLocale", void 0);
_defineProperty(Bridge, "getAllLocales", void 0);
_defineProperty(Bridge, "getIntl", void 0);
_defineProperty(Bridge, "getLocale", function () {
  return 'zh-CN';
});
_defineProperty(Bridge, "history", void 0);
_defineProperty(Bridge, "matchRoutes", void 0);
_defineProperty(Bridge, "MicroApp", void 0);
_defineProperty(Bridge, "setLocale", void 0);
_defineProperty(Bridge, "useAppData", void 0);
_defineProperty(Bridge, "useIntl", void 0);
_defineProperty(Bridge, "useLocation", void 0);
_defineProperty(Bridge, "useModel", void 0);
export var useInitialState = function useInitialState() {
  return Bridge.useModel('@@initialState');
};